import { ScoringTotalsWrapper, ScoringTotalsTable, ScoringTotalsRow, ScoringTotalsCell, ScoringTotalsCellDouble, ScoringTotalsColHeader, ScoringTotalsHeaderRow } from './styles';

const ScoringTotals = ({project}) => {
    const {siScore, siScoreVendor, siScoreNonBespoke, siScoreVendorNonBespoke,
        siScoreNoMaturity, siScoreVendorNoMaturity, siScoreNonBespokeNoMaturity, siScoreVendorNonBespokeNoMaturity} = project;

    return <ScoringTotalsWrapper>
        <ScoringTotalsTable>
            <ScoringTotalsRow>
                <ScoringTotalsCell></ScoringTotalsCell>
                <ScoringTotalsCellDouble>No correction for maturity</ScoringTotalsCellDouble>
                <ScoringTotalsCellDouble>Corrected for maturity</ScoringTotalsCellDouble>
            </ScoringTotalsRow>
            <ScoringTotalsHeaderRow>
                <ScoringTotalsColHeader></ScoringTotalsColHeader>
                <ScoringTotalsColHeader><div>All modules</div></ScoringTotalsColHeader>
                <ScoringTotalsColHeader><div>Non-bespoke modules</div></ScoringTotalsColHeader>
                <ScoringTotalsColHeader><div>All modules</div></ScoringTotalsColHeader>
                <ScoringTotalsColHeader><div>Non-bespoke modules</div></ScoringTotalsColHeader>
            </ScoringTotalsHeaderRow>
            <ScoringTotalsRow>
                <ScoringTotalsCell>Score including vendor modules</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreVendorNoMaturity}%</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreVendorNonBespokeNoMaturity}%</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreVendor}%</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreVendorNonBespoke}%</ScoringTotalsCell>
            </ScoringTotalsRow>
            <ScoringTotalsRow>
                <ScoringTotalsCell>Score excluding vendor modules</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreNoMaturity}%</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreNonBespokeNoMaturity}%</ScoringTotalsCell>
                <ScoringTotalsCell>{siScore}%</ScoringTotalsCell>
                <ScoringTotalsCell>{siScoreNonBespoke}%</ScoringTotalsCell>
            </ScoringTotalsRow>
        </ScoringTotalsTable>
    </ScoringTotalsWrapper>
};

export default ScoringTotals;